import React from 'react';
import ReactDOM from 'react-dom';

import './BottomSticky.scss';

const bottomStickyDOMNode = document.getElementById('mn_bottomSticky');

function BottomSticky({ children, className, setRef }) {
  return ReactDOM.createPortal(
    <div className={`mn_bottomSticky ${className || ''}`} ref={setRef}>{children}</div>,
    bottomStickyDOMNode,
  );
}

export default BottomSticky;
